import { ArrowsClockwise } from "@phosphor-icons/react";

/**
 * Modal to confirm regenerating the lyrics, with optional extra instructions
 * for the AI. Free first regen per song; subsequent ones cost 1 regen credit.
 */
export const RegenLyricsModal = ({
  open,
  regenInfo,
  instructions,
  setInstructions,
  loading,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-4" data-testid="regen-modal">
      <div className="w-full max-w-md bg-[#0a0a0a] border border-white/10 rounded-3xl p-6 shadow-2xl">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-[#B4F34A]/10 flex items-center justify-center">
            <ArrowsClockwise size={20} weight="bold" className="text-[#B4F34A]" />
          </div>
          <div>
            <h3 className="font-display text-xl font-bold">Regenerar letra</h3>
            <p className="text-xs text-white/50">
              {regenInfo?.kinds?.lyrics?.is_free_next
                ? "Este cambio es gratis (1 incluido por canción)"
                : `Se descontará 1 cambio extra ($20 MXN). Saldo: ${regenInfo?.regen_credits || 0}.`}
            </p>
          </div>
        </div>
        <label className="text-xs uppercase tracking-widest text-white/60 mb-2 block mt-4">
          ¿Quieres dar alguna instrucción extra a la IA? <span className="text-white/40 normal-case tracking-normal">opcional</span>
        </label>
        <textarea
          rows={4}
          value={instructions}
          onChange={(e) => setInstructions(e.target.value)}
          placeholder="Ej: que el coro sea más alegre, menciona a mi mamá Lupita, evita palabras tristes…"
          className="w-full px-4 py-3 rounded-xl bg-[#121212] border border-white/10 focus:border-[#FFB800] focus:outline-none transition-colors resize-none text-sm"
          data-testid="regen-instructions"
        />
        <div className="flex gap-3 mt-5">
          <button
            onClick={onCancel}
            disabled={loading}
            className="flex-1 py-3 rounded-full bg-white/5 border border-white/10 font-medium hover:bg-white/10 transition-all"
            data-testid="regen-cancel"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 py-3 rounded-full bg-[#B4F34A] hover:bg-[#A0E03A] disabled:opacity-50 text-black font-semibold transition-all active:scale-95"
            data-testid="regen-confirm"
          >
            {loading ? "Generando…" : "Sí, regenerar"}
          </button>
        </div>
      </div>
    </div>
  );
};
